import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";
import { STATUS_STYLES } from "../../constants";
import { fmtCurrency, fmtDateOrDash } from "../clientConstants";

const thCls = "text-[11px] font-semibold uppercase tracking-[0.1em] text-[#475467] bg-[#F7F9FC]";

export function OrdersPanel({ clientId, onOpenOrder }) {
  const [orders, setOrders] = useState(null);
  useEffect(() => { api.get(`/admin/clients/${clientId}/orders`).then((r) => setOrders(r.data)).catch(() => setOrders([])); }, [clientId]);
  if (orders === null) return <div className="text-sm text-slate-400 py-10 text-center">Loading orders…</div>;
  if (!orders.length) return <div data-testid="client-orders-empty" className="text-sm text-slate-400 py-10 text-center border border-dashed border-slate-200 rounded-lg">No orders yet for this client.</div>;
  return (
    <div data-testid="client-orders-panel" className="rounded-lg border border-[#E4E9F0] overflow-x-auto shadow-sm">
      <Table>
        <TableHeader><TableRow><TableHead className={thCls}>Job #</TableHead><TableHead className={thCls}>Property Address</TableHead><TableHead className={thCls}>Booking Date</TableHead><TableHead className={thCls}>Services</TableHead><TableHead className={thCls}>Total</TableHead><TableHead className={thCls}>Status</TableHead><TableHead className={thCls}></TableHead></TableRow></TableHeader>
        <TableBody>
          {orders.map((o) => (
            <TableRow key={o.id} data-testid={`client-order-row-${o.id}`} className="hover:bg-[#F8FAFC] transition-colors">
              <TableCell><span className="font-mono text-xs font-bold text-[#0C2347] bg-[#F0F4F8] px-2 py-0.5 rounded border border-[#CBD5E1]">#{o.job_number}</span></TableCell>
              <TableCell className="text-sm max-w-[200px] truncate font-medium text-[#101828]">{o.address}</TableCell>
              <TableCell className="text-sm whitespace-nowrap text-[#475467]">{fmtDateOrDash(o.scheduled_date)}</TableCell>
              <TableCell className="text-sm max-w-[220px] truncate text-[#475467]">{o.services}</TableCell>
              <TableCell className="text-sm font-semibold text-[#101828]">{fmtCurrency(o.total)}</TableCell>
              <TableCell><span className={`text-[11px] font-semibold tracking-wide px-2.5 py-0.5 ${STATUS_STYLES[o.status] || "rounded-full bg-[#F1F2F4] text-[#51565F]"}`}>{o.status}</span></TableCell>
              <TableCell><Button data-testid={`client-order-open-${o.id}`} variant="ghost" size="sm" className="rounded-lg text-xs font-semibold gap-1 hover:bg-[#0C2347] hover:text-white transition-colors" onClick={() => onOpenOrder(o.id, "overview")}>Open <ArrowUpRight size={13} /></Button></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
